module.exports = __webpack_public_path__ + "static/media/coin-effect.76ef466e.mp3";